import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { RFMConfigLevel } from '../interfaces/RFMConfigLevel';
import { NavLink, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { useTranslations } from 'use-intl';

const toggleButtons = [
  {
    labelKey: 'levels.businessUnit',
    value: RFMConfigLevel.BUSINESS_UNIT,
    to: './',
  },
  {
    labelKey: 'levels.productHierarchy',
    value: RFMConfigLevel.PRODUCT_HIERARCHY,
    to: './product-hierarchy',
  },
];

const Home = () => {
  const t = useTranslations('rfmConfig');
  const location = useLocation();

  // Determine current level based on URL
  const getCurrentLevel = () => {
    if (location.pathname.includes('product-hierarchy')) {
      return RFMConfigLevel.PRODUCT_HIERARCHY;
    }
    return RFMConfigLevel.BUSINESS_UNIT;
  };

  const currentLevel = getCurrentLevel();

  return (
    <Box>
      <ToggleButtonGroup
        sx={{ mb: '1rem' }}
        value={currentLevel}
        fullWidth
        exclusive
      >
        {toggleButtons.map(({ labelKey, value, to }) => (
          <ToggleButton
            key={value}
            value={value}
            component={NavLink}
            to={to}
            end={false}
          >
            {t(labelKey)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Outlet />
    </Box>
  );
};

export default Home;
